import React from "react";
import { ModalProvider } from "./Modal";

export default function RootProvider({ children }) {
  return (
    <ModalProvider>
      {children}
    </ModalProvider>
  );
}
